<template>
  <div class="modal fade" id="refundModal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="closeRefundModal" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title"><i class="fa fa-money mr-5"></i>{{'refund' | translate}}</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-xs-12">
              <label>{{'images' | translate}}:</label>
            </div>
            <br/>
            <ol>
              <li v-for="img, index in images">
                <img class="img-responsive img-preview" :src="img.path"/>
              </li>
            </ol>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <label class="pull-left">{{'decision' | translate}}:</label>
              <br/>
              <select v-model="decision" class="form-control">
                <option class="normal" value="accept">1. {{'accept' | translate}}</option>
                <option class="normal" value="decline">2. {{'decline' | translate}}</option>
              </select>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-xs-12">
              <label class="pull-left">{{decision === 'accept' ? 'amount' : 'message' | translate }}:</label>
            </div>
            <div class="col-xs-12">
              <div class="input-group">
                <div class="input-group-addon"><i :class="[decision === 'accept' ? 'fa fa-euro' : 'fa fa-edit']"></i></div>
                <input class="form-control" type="text" v-model="value"/>
              </div>
            </div>
          </div>
          <div class="row pt-10">
            <div class="col-xs-12">
              <button :disabled="value === ''" @click="$emit('action',[decision, value])" type="button" class="btn bg-success btn-app pull-right"><i class="fa fa-save"></i>{{'submit' | translate}}</button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn bg-danger btn-outline" data-dismiss="modal"><span class="fa fa-times mr-5"></span>{{'cancel' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['action', 'images'],
    data () {
      return {
        decision: 'accept',
        value: '',
        message: ''
      }
    },
    methods: {
    },
    mounted () {
    },
    watch: {
      images () {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/tools/Modals/RefundModal.vue